import { render } from "./CommonTreeMenu.vue?vue&type=template&id=6255a417&scoped=true&ts=true"
import script from "./CommonTreeMenu.vue?vue&type=script&lang=ts"
export * from "./CommonTreeMenu.vue?vue&type=script&lang=ts"

import "./CommonTreeMenu.vue?vue&type=style&index=0&id=6255a417&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6255a417"]])

export default __exports__